import { useEffect, useState } from 'react';

import { getServicePromise } from '../../HttpService/HttpService';
import { getControlDocumentsList } from '../../../Properties/Properties';


export function withDocumentsList(DocumentsListComponent) {
  return (props) => {
    const [fetchingOn, setFetchingOn] = useState(true);
    const [fetchError, setFetchError] = useState(null);
    const [documents, setDocuments] = useState([]);

    useEffect(() => {
      const callPromise = getServicePromise(
        getControlDocumentsList(props.controlUuid), 'GET');
      callPromise.then(
        function (documents_) {
          setDocuments(documents_.filter(document => !!document.file));
          setFetchingOn(false);
        },
        function (error) {
          setFetchError(error);
          setFetchingOn(false);
        }
      );
    }, []);

    return <DocumentsListComponent
      documents={documents}
      fetchError={fetchError}
      fetchingOn={fetchingOn}
      {...props}
    />
  }
}
